import React from 'react';
import { AppName } from 'sl-api-connector';
import {
  AdManagerLogo,
  AdvisorLogo,
  AtlasLogo,
  BeaconLogo,
  DiscoverLogo,
  OmniLogo,
  SvgElementProps
} from 'src/components/SvgIcons/SvgIcons';
import { getAppName } from 'src/utils/app';

const LogoIcon = (props: SvgElementProps) => {
  // Use getAppName() directly to get the correct app based on current URL
  // This ensures enterprise-sso with referrer param shows the correct logo
  const appName = getAppName();

  let LogoIconComponent = AtlasLogo;
  if (appName === AppName.Atlas) {
    LogoIconComponent = AtlasLogo;
  } else if (appName === 'Advisor') {
    LogoIconComponent = AdvisorLogo;
  } else if (appName === AppName.Omni) {
    LogoIconComponent = OmniLogo;
  } else if (appName === AppName.Beacon) {
    LogoIconComponent = BeaconLogo;
  } else if (appName === AppName.Discover) {
    LogoIconComponent = DiscoverLogo;
  } else {
    LogoIconComponent = AdManagerLogo;
  }

  return <LogoIconComponent {...props} />;
};

export default LogoIcon;
